<template>
  <v-navigation-drawer
    app
    permanent
    location="left"
    v-model="editdrawer"
    width="300"
    height="100%"
    class="k-app-sidebar"
  >
    <!-- <v-list > -->
      <dashboardScreen
        :pages="pages"
        @tab-selected="updateTabview"
        @edit-page="handleEditPage"
        @duplicate-page="handleDuplicatePage"
        @delete-page="handleDeletePage"
        :dashboardview="dashboardview"
      />

      <div class="pa-2">
        <v-btn
          @click="createNewPage"
          color="var(--primary)"
          variant="text"
          block
          class="btn bg-light"
          >Add page</v-btn
        >
      </div>
    <!-- </v-list> -->
  </v-navigation-drawer>
</template>

<script>
import dashboardScreen from "./dashboard-screen.vue";

export default {
  components: {
    dashboardScreen,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    pages: {
      type: Array,
      default: () => [],
    },
    dashboardview: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editdrawer: this.drawer,
    };
  },
  watch: {

    drawer(newValue) {
      this.editdrawer = newValue; // Sync parent drawer prop with local state
    },
    editdrawer(newValue) {
      this.$emit("open-left-drawer", newValue); // Emit event to parent when drawer state changes
    },
  },
  methods: {
    updateTabview(id) {
      this.$emit("tab-selected", id);
    },
    createNewPage() {
      this.$emit("create-new-page");
    },
    handleEditPage({ id, page_title }) {
      const pageIndex = this.pages.findIndex((view) => view.id === id);
      if (pageIndex !== -1) {
        this.$emit("update:pages", [
          ...this.pages.slice(0, pageIndex),
          { ...this.pages[pageIndex], page_title: page_title },
          ...this.pages.slice(pageIndex + 1),
        ]);
      }
    },
    handleDuplicatePage(element) {
      const newPage = { ...element, id: this.generateUniqueId() };
      this.$emit("update:pages", [...this.pages, newPage]);
    },
    handleDeletePage(id) {
      const updatedPages = this.pages.filter((view) => view.id !== id);
      this.$emit("update:pages", updatedPages);
    },
    generateUniqueId() {
      return "_" + Math.random().toString(36).substr(2, 9);
    },
  },


};
</script>
